export default __webpack_public_path__ + "static/media/eye.95048187.svg";